// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"a7be2508","626":"a7be2508","835":"0cd057b4"}[chunkId] + ".chunk.css";
};